export enum AvailableApps {
  "sensory" = "sensory",
  "luminary" = "luminary",
  "marketplace" = "marketplace",
  "symmetry" = "symmetry",
  "energpt" = "energpt",
  "leakfinder" = "leakfinder",
}
